export default "__VITE_ASSET__BRi7Wzrc__"